import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from './client';
import { AuthProvider } from './AuthContext';
import Layout from './Layout';
import PrivateRoute from './PrivateRoute';
import PublicationsPage from './pages/PublicationsPage';
import GravesPage from './pages/GravesPage';
import LithicsPage from './pages/LithicsPage';
import CeramicsPage from './pages/CeramicsPage';
import CeramicSimilaritiesPage from './pages/CeramicSimilaritiesPage';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import AnalyticsWorkspace from './pages/AnalyticsWorkspace';
import SitesPage from './pages/SitesPage';
import UsersPage from './pages/UsersPage';
import TeamsPage from './pages/TeamsPage';
import TagsPage from './pages/TagsPage';
import KioskPage from './pages/KioskPage';
import ApiTokensPage from './pages/ApiTokensPage';
import PublicationShowPage from './pages/PublicationShowPage';
import PublicationFormPage from './pages/PublicationFormPage';
import PublicationProgressPage from './pages/PublicationProgressPage';
import GraveShowPage from './pages/GraveShowPage';
import GraveEditPage from './pages/GraveEditPage';
import GraveRelatedPage from './pages/GraveRelatedPage';
import FigureShowPage from './pages/FigureShowPage';
import SizeFigureEditPage from './components/size_figure_wizard/SizeFigureEditPage';
import SiteShowPage from './pages/SiteShowPage';
import UserShowPage from './pages/UserShowPage';
import UserFormPage from './pages/UserFormPage';
import TeamShowPage from './pages/TeamShowPage';
import TeamFormPage from './pages/TeamFormPage';
import PageShowPage from './pages/PageShowPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <AuthProvider>
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              </AuthProvider>
            }
          >
            <Route path="/" element={<Navigate to="/graves" replace />} />
            <Route path="/graves" element={<GravesPage />} />
            <Route path="/graves/:id" element={<GraveShowPage />} />
            <Route path="/graves/:id/edit" element={<GraveEditPage />} />
            <Route path="/graves/:id/related" element={<GraveRelatedPage />} />
            <Route path="/lithics" element={<LithicsPage />} />
            <Route path="/lithics/:id" element={<FigureShowPage />} />
            <Route path="/figures/:figure_type/:id/edit" element={<SizeFigureEditPage />} />
            <Route path="/ceramics" element={<CeramicsPage />} />
            <Route path="/ceramics/:id/similarities" element={<CeramicSimilaritiesPage />} />
            <Route path="/analytics" element={<AnalyticsDashboard />} />
            <Route path="/analytics/workflows/:id" element={<AnalyticsWorkspace />} />
            <Route path="/publications" element={<PublicationsPage />} />
            <Route path="/kiosk" element={<KioskPage />} />
            <Route path="/publications/new" element={<PublicationFormPage />} />
            <Route path="/publications/:id/edit" element={<PublicationFormPage />} />
            <Route path="/publications/:id/progress" element={<PublicationProgressPage />} />
            <Route path="/publications/:id" element={<PublicationShowPage />} />
            <Route path="/sites" element={<SitesPage />} />
            <Route path="/sites/:id" element={<SiteShowPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/users/:id" element={<UserShowPage />} />
            <Route path="/users/:id/edit" element={<UserFormPage />} />
            <Route path="/teams" element={<TeamsPage />} />
            <Route path="/teams/new" element={<TeamFormPage />} />
            <Route path="/teams/:id" element={<TeamShowPage />} />
            <Route path="/teams/:id/edit" element={<TeamFormPage />} />
            <Route path="/tags" element={<TagsPage />} />
            <Route path="/pages/:id" element={<PageShowPage />} />
            <Route path="/api-tokens" element={<ApiTokensPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ApolloProvider>
  );
}
